import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const ScheduleList = ({ items }) => {
  const { t } = useTranslation();
  const list = Array.isArray(items) ? items : [];
  const [openItemIndex, setOpenItemIndex] = useState(null);

  // No items → render nothing. The readiness gate in pages/RSVP.jsx already
  // redirects to /not-ready when scheduleEntries is empty, so this branch
  // is defensive: never surface placeholder/sample content as if it were
  // the couple's real schedule.
  if (list.length === 0) return null;

  const toggleItem = (index) => {
    setOpenItemIndex(openItemIndex === index ? null : index);
  };

  const resolveTitle = (item) => item.title;
  const resolveDescription = (item) => item.description;

  return (
    <div className="faq-wrap w-dyn-list">
      <div role="list" className="job-list w-dyn-items">
        {list.map((item, index) => {
          const title = resolveTitle(item);
          const description = resolveDescription(item);
          const hasDescription = !!description?.trim();
          const isOpen = hasDescription && openItemIndex === index;

          return (
            <div key={index} role="listitem" className="job-item w-dyn-item">
              <div
                className="job-button"
                onClick={hasDescription ? () => toggleItem(index) : undefined}
                style={{ cursor: hasDescription ? "pointer" : "default" }}
              >
                <div className="button-icon job">
                  <img
                    src="/assets/photos/Button-Icon.svg"
                    alt={t("schedule.buttonAlt")}
                    loading="lazy"
                    className="b-icon"
                  />
                </div>
                <div className="job-content">
                  <h2 className="heading-38">{title}</h2>
                </div>
                {hasDescription && (
                  <div className="plus-div">
                    <div className="plus-line">
                      <div
                        className="plus-line _90"
                        style={{
                          transform: isOpen
                            ? "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
                            : "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(90deg) skew(0, 0)",
                          transition: "transform 0.4s ease",
                        }}
                      ></div>
                    </div>
                  </div>
                )}
              </div>

              {hasDescription && (
                <div
                  className="job-description"
                  style={{
                    height: isOpen ? "auto" : "1px",
                    overflow: "hidden",
                    opacity: isOpen ? 1 : 0,
                    transition: "height 0.4s ease, opacity 0.4s ease",
                  }}
                >
                  <div className="pad-20">
                    <div className="rich-text-block job w-richtext">
                      <h2 className="schedule" style={{ whiteSpace: "pre-line" }}>
                        {description}
                      </h2>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ScheduleList;
